import React from 'react';

import * as S from './styles';

type WordCloudProps = {
  title: string;
  items: WordCloudItem[];
};

type WordCloudItem = {
  name: string;
  url: string;
};

const WordCloud = ({ title, items }: WordCloudProps) => {
  return (
    <S.WordCloudContainer>
      <h3>{title}</h3>
      <S.WordCloudList>
        {items.map(({ name, url }) => (
          <S.WordCloudItem key={url}>
            <S.WordCloudLink to={url}>{name}</S.WordCloudLink>
          </S.WordCloudItem>
        ))}
      </S.WordCloudList>
    </S.WordCloudContainer>
  );
};

export default WordCloud;
